import { accountDetails } from "@di";
import React from "react";
import { eqOrder, eqProducts, eqValidity } from "../Equity/EqConstants";
export const StockData = [
    {
        title: "NSE",
        eventKey: "NSE",
    },
    {
        title: "BSE",
        eventKey: "BSE",
    },
];
export var placeorderTypeEnum;
(function (placeorderTypeEnum) {
    placeorderTypeEnum["BSE"] = "BSE";
    placeorderTypeEnum["NSE"] = "NSE";
})(placeorderTypeEnum || (placeorderTypeEnum = {}));
export var understandingSectionEnum;
(function (understandingSectionEnum) {
    understandingSectionEnum["PRODUCT"] = "PRODUCT";
    understandingSectionEnum["ORDER"] = "ORDER";
})(understandingSectionEnum || (understandingSectionEnum = {}));
export const productData = [
    {
        title: "Delivery Cash and Carry (CNC)",
        eventKey: "CNC",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Buy shares on Delivery and pay in full without using any margin. Buy shares for overnight (delivery) by paying the total order amount upfront. No Margin will be provided on CNC product type. Taking short positions will not be allowed in CNC however you can sell stocks from your holdings."),
            React.createElement("p", null, "Select if: You want to Buy scrips in delivery segment. Sell your Holding. Do not select if: You want to Buy on margin. Buy or sell intra-day. Short any scrip. Trade in futures and Options. Note: Total amount is required upfront, order will not go through in case your broking account does not have sufficient funds."))),
    },
    {
        title: "Delivery Plus (NRML)",
        eventKey: "NRML",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Buy shares on Delivery using Margin facility and pay in upto 5 days. Buy shares for overnight (delivery) by paying just a fraction of total order amount now and the remaining amount in next 5 days. NRML is also used for trading in Future and Options to carry forward your positions overnight. Interest is chargeable at xx% per annum."),
            React.createElement("p", null, "Select if: You want to trade in Futures and Options. You want to Buy scrips in delivery segment using margin (up to 5 days). Do not select if: Want to buy and hold using margins for more than 5 days. Buy or sell intra-day. Short any scrip. Note: Interest rate is charged at xx% per annum."))),
    },
    {
        title: "Margin Trade Funding (MTF)",
        eventKey: "MTF",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Buy shares on Delivery using Margin facility and pay in upto 360 days. Requires pledging of existing holdings. Buy shares for overnight (delivery) by paying just a fraction of total order amount now and the remaining amount in next 360 days by pledging existing stocks in holdings as collateral. This facility helps you increase your trading capacity by providing leverage against the pledge of existing stocks in portfolio which are invested for a longer term. Interest is chargeable at xx% per annum."),
            React.createElement("p", null, "Select if: You want to Buy scrips in delivery segment using margin (up to 360 days). Sell your MTF Holding. Do not select if: Buy or sell intra-day. Short any scrip. Note: You will need to pledge your holdings to enable you to use this order type. Interest rate is charged at xx% per annum."))),
    },
    {
        title: "Margin Intraday Square Off (MIS)",
        eventKey: "MIS",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "MIS is used for intraday trading using leverage in Equity, Equity F&O, Commodity futures and Currency futures. All positions created with MIS will be auto squared off by 3:15PM. Client can hold the stocks till 3:15PM or sell it off anytime before."),
            React.createElement("p", null, "Select if: Buy or sell intra-day for both delivery as well as F&O. Short any scrip. Do not select if: Buy on margin or delivery. Sell your holding. Note: All positions created with MIS will be auto squared off at 3:15 PM."))),
    },
    {
        title: "Bracket Order (BO)",
        eventKey: "BO",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Bracket Order (BO) \u2013 is an extension of MIS order but along with the initial buy or sell order, bracket order also has a second and a third leg for target and stop loss to square off the position. In a Bracket order, the target and stop loss orders are only placed after the initial order of Buy or sell is executed. Further the second and third leg of stop loss or target orders are on OCO Basis (One cancels other), which means that if the target order gets executed then stop loss order gets canceled and vice versa. In BO Order placement, initial order can only be placed as limit order while stop loss and target price are determined by points wherein 1 points = 1 Rupee."),
            React.createElement("p", null, "Select if: You wish to place a 3-legged order (applicable for intra-day for both delivery as well as F&O). Leg 1: Buy or sell Limit order. Leg 2: Target price order (input as points from Leg 1 Limit price). Leg 3: Stop loss order (input as points from Leg 1 Limit price). Note: Leg 2 or 3 are placed only on successful execution of leg 1 and is auto canceled if either of leg 2 or leg 3 is executed. Can also be used when shorting any scrip. Do not select if: You do not wish to close the trade on same day. If the levels at which you want to book profits or loss is not decided pre-hand. Note: All positions created with BO will be auto squared off at 3:15 PM. Trailing Stop Loss \u2013 Trailing stop loss lets you minimize the loss to be incurred on a trade. If you have bought a stock and set a trailing stop loss to sell the same, and the price rises in your favor, the stop price also increases with the stock price. . On the other hand if the price falls against you, the stop loss stays in place.with MIS will be auto squared off at 3:15 PM"))),
    },
];
export const orderData = [
    {
        title: "Limit Order",
        eventKey: "LIMIT",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Limit order allows you to place a buy or sell order for a stock at your desired price. Limit order should be preferred for placing orders in Il-liquid stocks wherein the difference between the bid price and the ask price of the stock is high, hence it saves you from buying a stock at higher price or selling the stock at a lower price. However, there is a chance that the order may not be executed as there may not be a counter order against the your desired price."),
            React.createElement("p", null, "Select if: You wish to place a trade (both buy & sell) at a specific price point. Placing an order in an illiquid scrip. Do not select if: You wish to place a trade (both buy & sell) at available market price at that point in time. Note: Buy limit order will be executed at Ask Price if the set limit price is more than the Ask Price Buy limit order will be executed at Bid Price if the set limit price is less than the Bid Price Placing a limit order does not guarantee the price at which your trade will be executed, it however controls when the order is placed such that price is favorable to your trade."))),
    },
    {
        title: "Market Order",
        eventKey: "MARKET",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Placing a market order allows you to buy/sell at the best available ask / bid price. Market orders are ideally placed when you wish to buy / sell a stock at best price currently available in the exchange market. While market orders can get immediate execution in exchange if there are any buys / sells for the stock, we recommend you to be careful and to go through the bid / ask prices (Market Depth) before placing the order especially for Il-liquid stocks. Limit orders will get executed as a market order if - \u2022 Buy limit order: limit price is more than the best offer price. \u2022 Sell limit order: limit price is less than the best bid price"),
            React.createElement("p", null, "Select if: You wish to place a trade (both buy & sell) at available market price at that point in time. Do not select if: You wish to place a trade (both buy & sell) at a specific price point. Trading in illiquid scrips. Note: We recommend you check the market depth before placing market order as the difference between the last trade price and the next open order price may be large leading to unfavorable price particularly in case of illiquid scrips."))),
    },
    {
        title: "Stop Loss Order",
        eventKey: "SL",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "A Stop loss order is a type of order which is aimed at limiting the losses as a protection against a price movement against your trade. A stoploss will have a trigger price and a limit price. The order will be pushed to the exchange only once the LTP crosses the trigger price and the order will get executed at limit price."))),
    },
    // {
    //   title: "Stop Loss Market",
    //   eventKey: "MIS",
    //   tabContent: (
    //     <>
    //       <p>
    //         A Stop loss Market order is a variant of Stop loss order where limit
    //         price for order execution is replaced by Market price. Hence Stoploss
    //         Market will have just the trigger price. The order will be pushed to
    //         the exchange only once the LTP crosses the trigger price and the order
    //         will get executed at Market price post being pushed to the exchange.
    //       </p>
    //     </>
    //   ),
    // },
];
export const ConverteColumn = [
    {
        columnName: "",
        arrows: false,
        key: "order",
    },
    {
        columnName: "",
        arrows: false,
        key: "icon",
        tdCustomFunction: (key) => {
            return (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "edel-icon-arrow-right1" })));
        },
    },
];
export const ConverteRows = [
    {
        order: "Sell Order",
    },
    {
        order: "Create GTT order",
    },
    {
        order: "Start ESIP ",
    },
];
export var TypeOfTOCOrder;
(function (TypeOfTOCOrder) {
    TypeOfTOCOrder["EQ"] = "EQ";
    TypeOfTOCOrder["FNO"] = "FNO";
})(TypeOfTOCOrder || (TypeOfTOCOrder = {}));
export const getTOCProduct_OrderType_Val = async () => {
    let products = await accountDetails.getProducts();
    let OrderType = await accountDetails.getOrderTypes();
    let Validity = await accountDetails.getValidity();
    return {
        productType: products,
        orderType: OrderType,
        advanceOptions: Validity,
    };
};
export const calculateMaxNoOfShares = (ltp, checkMarginEntity, rmsDetails) => {
    let maxNoOfShares = "-";
    if (checkMarginEntity && checkMarginEntity.availableCash) {
        maxNoOfShares = Math.floor(Number(checkMarginEntity.availableCash) / Number(ltp)).toString();
    }
    else if (rmsDetails && rmsDetails.cshAvl) {
        maxNoOfShares = Math.floor(Number(rmsDetails.cshAvl) / Number(ltp)).toString();
    }
    return maxNoOfShares;
};
export const calculateMaxNoOfSharesCO = (ltp, checkMarginEntity, limits) => {
    var _a;
    let maxNoOfShares = "-";
    maxNoOfShares = (parseInt((_a = limits === null || limits === void 0 ? void 0 : limits.lmt) === null || _a === void 0 ? void 0 : _a.lmAvl) / parseInt(ltp)).toString();
    return maxNoOfShares;
};
export const CreateTOCbuttonList = async (nseBse, TOCIgnoreList, amoSelected, isModify, modifyData, isBOSelected) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let acc_type = await accountDetails.getAccTyp();
    const x = await getTOCProduct_OrderType_Val();
    let products = x.productType.find((y) => y.exc === nseBse);
    let advValidity = x.advanceOptions.find((y) => y.exc === nseBse);
    let FinalButtons = {
        products: [],
        orderType: [],
        validity: [],
    };
    if (x) {
        if (products) {
            FinalButtons.products = (_b = (_a = products === null || products === void 0 ? void 0 : products.prd) === null || _a === void 0 ? void 0 : _a.filter((p) => !(TOCIgnoreList === null || TOCIgnoreList === void 0 ? void 0 : TOCIgnoreList.includes(p.prdVal))).map((l) => {
                var _a;
                return {
                    title: acc_type == "CO" ? (l.prdVal == "I" ? "MIS" : "NRML") : l.prdVal,
                    value: l.prdDpNm,
                    mainVal: l.mainVal,
                    disabled: isModify && (modifyData === null || modifyData === void 0 ? void 0 : modifyData.productType) !== l.prdVal ? true : false,
                    rank: (_a = eqProducts === null || eqProducts === void 0 ? void 0 : eqProducts.find((t) => t.value === l.prdVal)) === null || _a === void 0 ? void 0 : _a.rank,
                };
            })) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.rank - b.rank);
        }
        FinalButtons.orderType = (_e = (_d = (_c = x === null || x === void 0 ? void 0 : x.orderType) === null || _c === void 0 ? void 0 : _c.filter((p) => !(TOCIgnoreList === null || TOCIgnoreList === void 0 ? void 0 : TOCIgnoreList.includes(p.value)))) === null || _d === void 0 ? void 0 : _d.map((l) => {
            var _a, _b;
            return {
                title: l.key,
                value: l.value,
                disabled: isModify && amoSelected && (modifyData === null || modifyData === void 0 ? void 0 : modifyData.orderType) !== l.key
                    ? true
                    : (isBOSelected || amoSelected) && l.value !== ((_a = eqOrder[1]) === null || _a === void 0 ? void 0 : _a.value)
                        ? true
                        : false,
                rank: (_b = eqOrder.find((t) => t.title == l.key)) === null || _b === void 0 ? void 0 : _b.rank,
            };
        })) === null || _e === void 0 ? void 0 : _e.sort((a, b) => (a === null || a === void 0 ? void 0 : a.rank) - (b === null || b === void 0 ? void 0 : b.rank));
        FinalButtons.validity = (_h = (_g = (_f = advValidity === null || advValidity === void 0 ? void 0 : advValidity.validity) === null || _f === void 0 ? void 0 : _f.filter((p) => !(TOCIgnoreList === null || TOCIgnoreList === void 0 ? void 0 : TOCIgnoreList.includes(p.vaVal)))) === null || _g === void 0 ? void 0 : _g.map((l) => {
            var _a;
            return {
                title: l.vaVal,
                value: l.dpNm,
                disabled: false,
                rank: (_a = eqValidity.find((t) => {
                    return t.value == l.vaVal;
                })) === null || _a === void 0 ? void 0 : _a.rank,
            };
        })) === null || _h === void 0 ? void 0 : _h.sort((a, b) => a.rank - b.rank);
    }
    return FinalButtons;
};
